var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPickDate = function SvgPickDate(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 10a39 39 0 0 1 39 38.36V66h-8V49a31 31 0 0 0-30.49-31H45a31 31 0 0 0-31 30.49V87a31 31 0 0 0 30.49 31H67v8H45A39 39 0 0 1 6 87.64V49a39 39 0 0 1 38.36-39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 0h4a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V2c0-1.1.9-2 2-2m46 0h4a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V2c0-1.1.9-2 2-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83 10a39 39 0 0 1 39 38.36V78h-8V49a31 31 0 0 0-30.49-31H45a31 31 0 0 0-31 30.49V87a31 31 0 0 0 30.49 31H77v8H45A39 39 0 0 1 6 87.64V49a39 39 0 0 1 38.36-39z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118 72v8h-8a31 31 0 0 0-31 30.49V121h-8v-10a39 39 0 0 1 38.36-39z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.67 67c4.54 8.12 2.23 21.94-5.74 30.18l-.33.34-19.8 19.8C85.55 125.57 79.33 126 77 126l-7.55-7.48c10.55 0 13.39-1.76 18.39-6.56l.3-.3 19.8-19.8a19.99 19.99 0 0 0 5.38-18.5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPickDate);
export default ForwardRef;